export const APP_NAME = 'backlot-front';

export const API_SERVER = 'https://api.totus.pro/backlot/v1';

export const AWS_LOCATION = 'ap-northeast-2';

// Development
export const MINGLO_GOOGLE_ID = '531615564546-r37h3taosrvdtas2lo4nqdvi4dp38l8k.apps.googleusercontent.com';
